// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1f0b867d","977":"26374d4c"}[chunkId] + ".chunk.js";
};